import React from "react";
import { useApp } from "@/context/AppContext";
import { ASSETS } from "@/lib/assets";
import { Wrench, Sparkles } from "lucide-react";

export default function Maintenance({ adminPreview = false, onEnter }) {
  const { lang, setLang, settings, user } = useApp();
  const msg = lang === "hi" ? settings.maintenance_message_hi : settings.maintenance_message_en;
  return (
    <div className="app-bg min-h-screen grid place-items-center px-6 text-center" data-testid="maintenance-page">
      <div className="max-w-lg rise-in">
        <img src={ASSETS.logo} alt="AstroFriend" className="mx-auto h-20 w-20 rounded-full ring-2 ring-amber-400/50 object-cover mb-6" />
        <div className="font-serif text-3xl font-bold text-gradient-gold mb-6">AstroFriend</div>
        <div className="mx-auto mb-6 h-16 w-16 rounded-full grid place-items-center border border-amber-500/40 bg-purple-900/50">
          <Wrench className="text-amber-300" size={28} />
        </div>
        <h1 className="font-serif text-2xl sm:text-3xl text-amber-100">{lang === "hi" ? "थोड़ी देर के लिए रखरखाव जारी है" : "We'll be back shortly"}</h1>
        <p className="mt-4 text-slate-300 leading-relaxed" data-testid="maintenance-message">{msg}</p>
        <p className="mt-3 text-xs text-amber-200/60 flex items-center justify-center gap-2"><Sparkles size={12} /> {lang === "hi" ? "आपकी सहेजी हुई रीडिंग सुरक्षित हैं।" : "Your saved readings are safe."}</p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <button onClick={() => setLang(lang === "hi" ? "en" : "hi")} className="btn-ghost-gold rounded-full px-5 py-2 text-sm" data-testid="maintenance-lang-btn">{lang === "hi" ? "English" : "हिंदी"}</button>
          {adminPreview && user?.is_admin && (
            <button onClick={onEnter} className="btn-gold rounded-full px-5 py-2 text-sm" data-testid="maintenance-admin-enter">Admin: {lang === "hi" ? "साइट खोलें" : "Enter site"}</button>
          )}
        </div>
      </div>
    </div>
  );
}
